module.exports = __webpack_public_path__ + "img/right_md_2.2696d9c7.jpg";